export const calcPercent = (value: number | undefined, total: number | undefined): number => {
	const v = value ?? 0;
	const t = total ?? 0;

	if (t <= 0) {
		return 0;
	}

	return (v / t) * 100;
};

export const formatPercent = (pct: number, digits = 2): string => {
	return `${pct.toFixed(digits)}%`;
};

export const formatNumber = (value: number | undefined): string => {
	if (value === undefined || value === null || Number.isNaN(value)) {
		return "0";
	}

	return new Intl.NumberFormat().format(value);
};
